const parserHex = (color: string) => {
  const hex = color.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return { r, g, b }
}

export const colorHexToRgb = (color: string) => {
  const { r, g, b } = parserHex(color)
  return {
    backgroundColor: `rgb(${r},${g},${b})`
  }
}

export const colorHexToRgbWithAlpha = (color: string, alpha: number) => {
  const { r, g, b } = parserHex(color)
  return {
    backgroundColor: `rgba(${r},${g},${b},${alpha})`
  }
}

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}
